var swiper = new Swiper(".collection-slider-custom", {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: false,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        550: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
        }
    }
});
tab_buttons = document.querySelectorAll("div[data-tab-nav-for]");
tab_buttons.forEach(function(tab_button){
    tab_button.addEventListener("click", function(){
        tab_button_value = this.getAttribute("data-tab-nav-for");

        tab_buttons.forEach(function(ee){
            if(ee.getAttribute("data-tab-nav-for") === tab_button_value){
                ee.classList.add("active");
            }else{
                ee.classList.remove("active");
            }
        });

        tab_contents = document.querySelectorAll("div[data-tab-content-for]");

        tab_contents.forEach(function(tab_content){
            if(tab_content.getAttribute("data-tab-content-for") === tab_button_value){
                tab_content.classList.add("active");
                console.log(tab_content);
            }else{
                tab_content.classList.remove("active");
            }
        });
    });
});